<script lang="ts" setup>
    import {ref, computed, watch} from 'vue';
    import { useClamp } from '@vueuse/math';
    import { useSorted } from '@vueuse/core'
    let range = defineModel<Number[]>('range',{
        'default': [], required: true
    });

    let props = defineProps({
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 500
        }
    })

    const valueA = ref<number>(range.value[0] != undefined ? +range.value[0] : +props.min);
    const valueB = ref<number>(range.value[1] != undefined ? +range.value[1] : +props.max);

    const valuesArr = computed(()=>([+valueA.value, +valueB.value]))
    const sortedValues = useSorted(valuesArr, (a, b) => +a - +b);

    const keepInputsWithinBounds = ()=>{
        valueA.value = +range.value[0];
        valueB.value = +range.value[1];
    }

    watch(()=>(sortedValues.value), (newVals)=>{
        range.value = newVals.map(val=>useClamp(val, +props.min, +props.max).value);
    }, {deep: true})
    
</script>
<template>
    <div class="range-container">
        <div class="range-control">
            <input id="range-from" type="range" :min="min" :max="max" v-model.number.lazy="valueA"/>
            <input id="range-to" type="range" :min="min" :max="max" v-model.number.lazy="valueB"/>
        </div>
        <div class="price-control">
            <div class="input-folder">
                <input type="text" id="price_from" name="name" maxlength="8" placeholder="from" :min="min" :max="max" required v-model.number.lazy="range[0]"
                    @change="keepInputsWithinBounds()"/>
                <label for="price_from" class="floating-label">$</label>
            </div>
            <div class="input-folder">
                <input type="text" id="price_to" name="name" class="input-field" placeholder="to" :min="min" :max="max" required v-model.number.lazy="range[1]"
                    @change="keepInputsWithinBounds()"/>
                <label for="price_to" class="floating-label">$</label>
            </div>
        </div>
        <div class="input-support-text">Max Price: ${{ (max).toFixed(2) }}</div>
    </div>
</template>
